export class UserPreference {
    Favorites: UserPreference.Favorite[];
    SelectedFavorite: number;
    FilterPast: boolean;
    SelectedView: string;
    UseAPIVersion: number;
}

export namespace UserPreference {
    export class Favorite {
        Code: string;
        Channels: Channel[];
    }

    export class Channel {
        Code: string;
        Name: string;
        LogoURL: string;
    }
}


// WEBPACK FOOTER //
// D:/OTHERS/FirstmediaShowSchedule/src/app/user-preference/user-preference.ts